import { Box, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { useRecoilValue } from 'recoil';
import StructureSetItem from '~/components/Structures/StructureSetItem';
import { useStructureSetDeletion } from '~/hooks/dataset/useStructureSetDeletion';
import { useAvailableStructureSetsView } from '~/hooks/domain/useAvailableStructureSetsView';
import useConfirmedSelection from '~/hooks/datasetSelection/useConfirmedSelection';
import { currentStructureSetIdState } from '~/state/atoms/structureSet/structureSetAtoms';

export default function StructureSetList() {
    const availableStructureSets = useAvailableStructureSetsView(true);
    const currentStructureSetId = useRecoilValue(currentStructureSetIdState);
    const { pickStructureSet } = useConfirmedSelection();
    const deletion = useStructureSetDeletion();

    if (availableStructureSets.length === 0) {
        return null;
    }

    return (
        <>
            <Box>
                <Box px={2} pt={1.5} pb={1}>
                    <Typography fontSize={12} color="primary" fontWeight={500}>
                        <FormattedMessage id="structureSets" />
                    </Typography>
                </Box>
                {availableStructureSets.map((ss) => {
                    const isActive =
                        currentStructureSetId === ss.sopInstanceUid;
                    return (
                        <Box
                            key={ss.sopInstanceUid}
                            borderTop="1px solid"
                            borderColor="divider"
                        >
                            <StructureSetItem
                                structureSet={ss}
                                isActive={isActive}
                                allowReselect
                                onClick={() => pickStructureSet(ss)}
                                onDelete={
                                    deletion.canRemove(ss)
                                        ? () => deletion.remove(ss)
                                        : undefined
                                }
                            />
                        </Box>
                    );
                })}
            </Box>

            {deletion.dialog}
        </>
    );
}
